import React from 'react';
import Translation from '../translation/translation';

function FSFMotoLightBoxHeader() {
    return (
        <div className="fsf-moto-light-box__header fsf-moto-light-box-header">
            <Translation
                translationKey="fsf-moto-light-box-header"
                className="fsf-moto-light-box-header__headline"
            />
        </div>
    );
}

export { FSFMotoLightBoxHeader };